import React from 'react';
import PropTypes from 'prop-types';
import { Helmet as ReactHelmet } from 'react-helmet';

import getEnvironment from '../../utils/getCurrentEnv';
import resolveEnvTheme from '../../utils/envTheme';
import { useTheme } from '../../theme/ThemeProvider';
import { NAV_COLORS } from '../../theme/palettes';

const Helmet = ({ title = '', description = '' }) => {
  const defaultTitle = 'Integration Framework';
  const defaultDescription = 'Integration Framework Web Application';

  // Prefix the tab title with the environment (e.g. "[QA] …") on non-prod so
  // QA/Staging/Prod tabs are distinguishable in the browser tab bar.
  const envTheme = resolveEnvTheme(
    getEnvironment(process.env.REACT_APP_BASE_URL),
  );
  const envPrefix = envTheme ? `[${envTheme.label}] ` : '';

  const { theme } = useTheme();
  const themeColor = NAV_COLORS[theme];

  const baseTitle = title ? `${title} | ${defaultTitle}` : defaultTitle;
  const fullTitle = `${envPrefix}${baseTitle}`;

  return (
    <ReactHelmet>
      <title>{fullTitle}</title>

      {/* Link Preview meta tags */}
      <meta property="og:title" content={fullTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta
        property="og:description"
        content={description || defaultDescription}
      />
      <meta content="website" property="og:type" />
      <meta name="theme-color" content={themeColor} />
    </ReactHelmet>
  );
};
Helmet.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default Helmet;
